"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const common_1 = require("../../../_styles/common");
const light_1 = require("./light");
const scrollbarDark = {
    name: 'Scrollbar',
    common: common_1.commonDark,
    self: light_1.self
};
exports.default = scrollbarDark;
